import { render, staticRenderFns } from "./ExportDefault.vue?vue&type=template&id=52c5721d"
import script from "./ExportDefault.vue?vue&type=script&lang=js"
export * from "./ExportDefault.vue?vue&type=script&lang=js"
import style0 from "./ExportDefault.vue?vue&type=style&index=0&id=52c5721d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports